import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import ArrowGroup from '../assets/svg/group-chevron.inline.svg'

const CsHeadShowcase = ({
  heading1,
  description1,
  heading2,
  description2,
  id = '',
}) => {

  function moveSlider(e, clientX) {
    let elementRect = e.currentTarget.getBoundingClientRect()
    let imagePosX = clientX - elementRect.left
    let imagePosXRight = elementRect.right - clientX
    const imgOnTop = document.querySelectorAll('.top-image')

    imgOnTop.forEach((img) => {
      if (!img.parentElement.hasAttribute('hidden')) {
        img.style.clipPath = 'inset(0 0 0 ' + imagePosX + 'px)'
      }
    })
    const slider = document.querySelector('.showcase-slider')

    if (imagePosX >= 0 && imagePosXRight >= 0) {
      slider.style.left = imagePosX + 'px'
    }
  }


  return (
    <div
      id={id}
      className='lg:pt-[85px] container bg-gray-100 flex flex-col overflow-hidden'
    >
      <div className='relative lg:-mr-[80px] lg:pl-0 lg:mx-0 md:pl-[45px] lg:flex  md:-mx-[45px] pt-[45px] -mx-[24px]'>

        <div
          role='presentation'
          className='relative xl:h-[945px] lg:h-[860px] md:h-[650px] w-full h-[calc(60vw)]'
          onMouseMove={(e) => moveSlider(e, e.clientX)}
          onTouchMove={(e) => moveSlider(e, e.touches[0].clientX)}
          onMouseEnter={() => {
            const customCursor = document.getElementById('custom-cursor')

            if (customCursor !== null) {
              customCursor.style.opacity = '0'
            }
          }}
          onMouseLeave={() => {
            const customCursor = document.getElementById('custom-cursor')

            if (customCursor !== null) {
              customCursor.style.opacity = '1'
            }
          }}
        >
          <div className='showcase-slider absolute left-[200px] h-full w-[1px] bg-orange z-[3] touch-none cursor-none'>
            <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[46px] h-[46px] rounded-full z-[3] bg-orange flex items-center justify-center cursor-none'>
              <ArrowGroup className='cursor-none' />
            </div>
          </div>
          <div

            className='w-full h-full touch-none cursor-none'
          >
            <StaticImage
              src='../assets/imgs/CSHead/cs_head_before.jpg'
              className='!absolute top-0 left-0 w-full h-full z-[1]'
              objectPosition='50% 75%'
              alt='Vehicle with original background'
            />
            <StaticImage
              src='../assets/imgs/CSHead/cs_head_after.jpg'
              className='top-image !absolute top-0 left-0 w-full h-full z-[2]'
              style={{ clipPath: 'inset(0 0 0 200px)' }}
              objectPosition='50% 75%'
              alt='Removed background behind the car'
            />
          </div>
        </div>
      </div>
      <div className='container md:pb-[120px] md:pt-[70px] pt-[40px] pb-[48px]'>
        <div className='md:flex-row md:gap-[16px] shrink-0 flex flex-col'>
          <div className='md:basis-1/2'>
            <h2
              className='md:text-[32px] text-xl mb-[24px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {heading1}
            </h2>
            <p
              className='md:mb-0 text-lg mb-[40px]   lg:max-w-[500px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {description1}
            </p>
          </div>
          <div className='md:basis-1/2'>
            <h2
              className='md:text-[32px] text-xl mb-[24px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {heading2}
            </h2>
            <p
              className='md:mb-0 text-lg mb-[40px] lg:max-w-[500px]'
              data-aos='fade-up'
              data-aos-duration='500'
              data-aos-easing='ease-in-out'
            >
              {description2}
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default CsHeadShowcase
